import { useRef } from 'react'
import { OfferBlockType } from '../../models/shared/Offer';
import { AdvancedButton } from '../AdvancedButton';
import { useText } from '../../context/TextContext';
import { OverlayTrigger, Popover } from 'react-bootstrap';

interface Props {
    ix: number;
    onAddBlock: (type: OfferBlockType, ix: number) => void;
}


export default function NewBlock(props: Props) {
    const text = useText();
    const buttonRef = useRef<HTMLButtonElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    const closeOverlay = () => containerRef.current?.click();

    const handleAddBlock = (type: OfferBlockType) => {
        props.onAddBlock(type, props.ix);
        closeOverlay();
    };

    return (
        <div className='position-relative new-block-line' style={{ height: 0 }} ref={containerRef}>

            <OverlayTrigger
                trigger="click"
                placement='left'
                rootClose
                overlay={
                    <Popover className="block-type-popover">
                        <div className="d-flex flex-column">
                            <BlockOption
                                icon="bi-type-h1"
                                label={text.headingBlock}
                                onClick={() => handleAddBlock('heading')}
                            />
                            <BlockOption
                                icon="bi-text-paragraph"
                                label={text.textBlock}
                                onClick={() => handleAddBlock('text')}
                            />

                            <BlockOption
                                icon="bi-hr"
                                label="Spacer"
                                onClick={() => handleAddBlock('spacer')}
                            />
                            <BlockOption
                                icon="bi-table"
                                label="Line Items"
                                onClick={() => handleAddBlock('lineItems')}
                            />
                            <BlockOption
                                icon="bi-people"
                                label={text.organizationCustomerBlock}
                                onClick={() => handleAddBlock('orgCustomer')}
                            />
                            <BlockOption
                                icon="bi-geo-alt"
                                label="Map"
                                onClick={() => handleAddBlock('map')}
                            />
                            <BlockOption
                                icon="bi-images"
                                label={text.attachments}
                                onClick={() => handleAddBlock('attachments')}
                            />

                        </div>
                    </Popover>
                }
            >

                <AdvancedButton
                    ref={buttonRef}
                    icon='bi-plus'
                    size='sm'
                    variant='outline-primary'
                    className='rounded-circle position-absolute new-block-button'
                    style={{ top: 0, right: -40, zIndex: 1, transform: 'translate(0, -50%)' }}
                />
            </OverlayTrigger>


        </div>
    );
}

interface BlockOptionProps {
    icon: string;
    label: string;
    onClick: () => void;
    disabled?: boolean;
}

function BlockOption({ icon, label, onClick, disabled = false }: BlockOptionProps) {
    return (
        <div
            className={`d-flex align-items-center px-3 py-2 cursor-pointer block-option ${disabled ? 'opacity-50' : ''}`}
            onClick={disabled ? undefined : onClick}
            style={{
                cursor: disabled ? 'not-allowed' : 'pointer',
                borderRadius: '4px'
            }}
        >
            <i className={`bi ${icon} me-2`}></i>
            <span>{label}</span>
        </div>
    );
}
